/** Shared audio constants and utilities. */

export const LANE_COLORS = ['#4a90d9', '#d94a8a', '#4ad97a', '#d9a54a'];

/** Pick a recording MIME type that the current browser can both
 *  encode (MediaRecorder) AND decode (AudioContext.decodeAudioData).
 *  audio/mp4 (AAC) is preferred because Safari/WKWebView decode it
 *  reliably; Chrome 112+ also supports it. Falls through to webm
 *  for Firefox and older Chrome. Empty string = browser default. */
export function getRecordingMimeType(): string {
  if (typeof MediaRecorder === 'undefined') return '';
  const candidates = [
    'audio/mp4',
    'audio/webm;codecs=opus',
    'audio/webm',
  ];
  for (const mime of candidates) {
    if (MediaRecorder.isTypeSupported(mime)) return mime;
  }
  return '';
}
